import React, { useState } from "react";
import { Mail, Phone, MapPin, Send, Facebook, Twitter, Linkedin } from 'lucide-react';
import toast from "react-hot-toast";
import { EditableText } from '../components/EditableText';

function ContactUs() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: ""
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    toast.success("Thank you! Your message has been received. We'll get back to you soon.");
    setFormData({ name: "", email: "", subject: "", message: "" });
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="min-h-screen py-16 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Page Header */}
        <div className="text-center mb-16">
          <h1 className="text-5xl font-bold mb-4 text-black">
            <EditableText page="contact" section="header" field="title" defaultValue="Contact Us" />
          </h1>
          <p className="text-gray-600 text-lg">
            <EditableText page="contact" section="header" field="subtitle" defaultValue="Get in touch with MOBA91." />
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
          {/* Contact Form */}
          <div className="bg-white border-2 border-gray-200 rounded-2xl p-8 shadow-lg">
            <h2 className="text-2xl font-bold mb-6 text-[#DC143C]">
              <EditableText page="contact" section="form" field="title" defaultValue="Send us a Message" />
            </h2>
            
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Your Name</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 bg-white border-2 border-gray-300 rounded-lg text-black placeholder-gray-400 focus:outline-none focus:border-[#DC143C] transition-all"
                  placeholder="Enter your full name" />

              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Email Address</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 bg-white border-2 border-gray-300 rounded-lg text-black placeholder-gray-400 focus:outline-none focus:border-[#DC143C] transition-all"
                  placeholder="your.email@example.com" />

              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Subject</label>
                <input
                  type="text"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 bg-white border-2 border-gray-300 rounded-lg text-black placeholder-gray-400 focus:outline-none focus:border-[#DC143C] transition-all"
                  placeholder="What is this about?" />

              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Message</label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows={6}
                  className="w-full px-4 py-3 bg-white border-2 border-gray-300 rounded-lg text-black placeholder-gray-400 focus:outline-none focus:border-[#DC143C] transition-all resize-none"
                  placeholder="Tell us more..." />

              </div>

              <button
                type="submit"
                className="w-full px-6 py-4 bg-[#DC143C] hover:bg-red-600 rounded-lg font-semibold transition-all transform hover:scale-105 flex items-center justify-center space-x-2">

                <Send size={20} />
                <span>Send Message</span>
              </button>
            </form>
          </div>

          {/* Contact Information */}
          <div className="space-y-8">
            {/* Contact Details */}
            <div className="bg-white border-2 border-gray-200 rounded-2xl p-8 shadow-lg">
              <h2 className="text-2xl font-bold mb-6 text-[#DC143C]">
                <EditableText page="contact" section="info" field="title" defaultValue="Get in Touch" />
              </h2>
              
              <div className="space-y-6">
                <ContactItem
                  icon={<Mail />}
                  label="Email"
                  value="info@moba91.org"
                  link="mailto:info@moba91.org" />

                <ContactItem
                  icon={<Phone />}
                  label="Phone"
                  value={<EditableText page="contact" section="info" field="phone" defaultValue="+233 XX XXX XXXX" />}
                  link="tel:+233XXXXXXXXX" />

                <ContactItem
                  icon={<MapPin />}
                  label="Location"
                  value={<EditableText page="contact" section="info" field="location" defaultValue="Cape Coast, Ghana" />} />

              </div>
            </div>

            {/* Social Media */}
            















            {/* Quick Info */}
            











          </div>
        </div>
      </div>
    </div>);

}

function ContactItem({ icon, label, value, link }: any) {
  const content =
  <div className="flex items-start space-x-4 text-[#000000] bg-[#991B1B] text-2xl">
      <div className="w-12 h-12 bg-[#DC143C]/10 rounded-lg flex items-center justify-center flex-shrink-0">
        <div className="text-[#DC143C]">{icon}</div>
      </div>
      <div>
        <div className="text-sm text-gray-600 mb-1">{label}</div>
        <div className="font-medium text-[#FFFFFF]">{value}</div>
      </div>
    </div>;


  if (link) {
    return (
      <a href={link} className="block hover:opacity-75 transition-opacity">
        {content}
      </a>);

  }

  return <div>{content}</div>;
}

function SocialButton({ icon, href, label }: any) {
  return (
    <a
      href={href}
      aria-label={label}
      className="w-12 h-12 bg-[#2A2A2A] hover:bg-[#DC143C] rounded-lg flex items-center justify-center transition-all transform hover:scale-110">

      {icon}
    </a>);

}

export default ContactUs;